import { useEffect, useState } from "react";

const Disclaimer = () =>{

    return(<> 

{/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
     <img src="assets/img/banner/about-banner.jpg" alt="MeriPustak-About"/>
       
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center">
                   
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Disclaimer :</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                              www.meripustak.com dutifully follows various copyright laws. We hereby declare that – All the book related materials, descriptions, images, data, information and supporting content is collected from multiple sources, which were released or presented for the purpose of public use and promotional requirements. Most of the materials are taken from various media kits or promotional media forums. Such images and related material strictly belong to the third-party sources, which are the parent sources to them. Thus, the third parties, respective publishers enjoy the sole intellectual property rights attached to the images, information, and content. www.meripustak.com is only using them for the purpose of promotion; no part or full has been altered or spun around for any other purpose, which can be stated as a commercial use other than the promotion. While publishing various contents on the page, due care is taken to avoid any material, which falls under copyright implications or intellectual property rights. In the case of an oversight, we are ready to remove such materials on the request and report. If any publisher or third-party finds any such content, image, data or information, then it can be removed from the page after getting an information/report from the side of concerned parties. Third parties and others can report these instances to <a href="mailto:contactus@meripustak.com">contactus@meripustak.com</a></p>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">or make a call at <b>"+91-837-396-8037/ 011-484-05001 / 011-484-05066 / 011-484-05077"</b></p>
							
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">All material/reports found to protected under any law for preventing it from free use of public will be immediately removed on request.</p>
						
							
                        </div>
                    </div>
                </div>
				
				
				
				
            </div>
        </div>
    </section>

    </>);

}

export default Disclaimer;